import dayjs from 'dayjs';
import { appI18n, toDayjsDateFormat } from '@flowus/common/i18n';
import { TIME_FORMAT } from '../const';

const getLocalizedDateFormat = () => toDayjsDateFormat(appI18n.t('common.date_format_ymd_no_time'));
const getLocalizedDateTimeFormat = () => `${getLocalizedDateFormat()} HH:mm`;
const getLocalizedDateTimeSpecificFormat = () => `${getLocalizedDateFormat()} HH:mm:ss`;

export function formatTimestamp(timestamp: number): string {
  return dayjs(timestamp).format(getLocalizedDateTimeFormat());
}

export function formatSpecificTimestamp(timestamp: number): string {
  return dayjs(timestamp).format(getLocalizedDateTimeSpecificFormat());
}

export function formatDotTimestamp(timestamp: number): string {
  return dayjs(timestamp).format(getLocalizedDateFormat());
}

export function formatFileTimestamp(timestamp: number): string {
  return dayjs(timestamp).format(getLocalizedDateTimeFormat());
}

/**
 * @params time 毫秒
 */
export function covertToHumanReadableTime(time: number) {
  if (time <= 0) return appI18n.t('common.utils.just_now');
  const timestamp = time * 1.0;
  const second = timestamp / 1000;
  const minute = Math.floor(second / 60);
  if (minute === 0) return appI18n.t('common.utils.just_now');
  const hour = Math.floor(minute / 60);
  if (hour === 0) return appI18n.t('common.utils.minutes_ago', { count: minute });
  const day = Math.floor(hour / 24);
  if (day === 0) return appI18n.t('common.utils.hours_ago', { count: hour });
  const month = Math.floor(day / 30);
  if (month === 0) return appI18n.t('common.utils.days_ago', { count: day });
  const year = Math.floor(month / 12);
  if (year === 0) return appI18n.t('common.utils.months_ago', { count: month });
  return appI18n.t('common.utils.years_ago', { count: year });
}
export function covertToPrivateListTime(time: number) {
  if (time <= 0) return appI18n.t('common.utils.today');

  const now = dayjs();
  const timestamp = dayjs(time);

  if (timestamp.isSame(now, 'day')) {
    return appI18n.t('common.utils.today');
  }

  if (timestamp.isSame(now.subtract(1, 'day'), 'day')) {
    return appI18n.t('common.utils.yesterday');
  }

  const diffDays = now.diff(timestamp, 'day');
  if (diffDays <= 7) {
    return appI18n.t('common.utils.last_week');
  }

  return appI18n.t('common.utils.earlier');
}

/** 转换时间格式 - block最后编辑时间 */
export const convertToLastEditTime = (time?: number) => {
  if (!time) return null;
  const now = dayjs();
  const timestamp = dayjs(time);

  if (timestamp.isSame(now, 'day')) {
    return [appI18n.t('common.utils.today'), timestamp.format(TIME_FORMAT)].join(' ');
  } else if (timestamp.isSame(now.subtract(1, 'day'), 'day')) {
    return [appI18n.t('common.utils.yesterday'), timestamp.format(TIME_FORMAT)].join(' ');
  } else if (now.diff(timestamp, 'day') === 2) {
    return [appI18n.t('common.utils.day_before_yesterday'), timestamp.format(TIME_FORMAT)].join(
      ' '
    );
  } else if (timestamp.isSame(now, 'year')) {
    // 只要不是今年的就带上年份
    return timestamp.format(toDayjsDateFormat(appI18n.t('time.short_date_time')));
  }
  return timestamp.format(toDayjsDateFormat(appI18n.t('common.date_format_ymd')));
};
